import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@mui/material/Typography'

import MainMenu from '../../Components/NodeCapeeshPlayer/MainMenu/MainMenu'
import { studentActions } from '../../_state/actions'
import { studentAuthConstants } from '../../_state/actions/studentAuth.actions'
import { CapeeshColors } from '../../assets/ColorPalette'

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: CapeeshColors.EggShell2,
        backgroundImage: 'radial-gradient(circle at 1px 1px, rgb(225, 225, 221) 1px, transparent 0)',
        backgroundSize: '12px 12px',
    },
    loadingContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
    },
    errorContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 32,
    },
}))

const StudentEmbed = (props) => {
    const { dispatch, studentAuth } = props
    const classes = useStyles()
    const [error, setError] = useState(null)
    const [tokenApplied, setTokenApplied] = useState(false)

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const token = urlParams.get('token')

        if (!token) {
            setError('Missing authentication token. Please ensure the embed URL includes a valid token parameter.')
            return
        }

        const authData = { token }
        localStorage.setItem('authToken', JSON.stringify(authData))

        dispatch({ type: studentAuthConstants.STUDENT_LOGIN.SUCCESS, data: authData })
        setTokenApplied(true)
    }, [])

    useEffect(() => {
        if (tokenApplied && studentAuth.studentLoggedIn) {
            dispatch(studentActions.getStudentInfo('web'))
            dispatch(studentActions.getStudentLanguageMetadata())
        }
    }, [tokenApplied, studentAuth.studentLoggedIn])

    if (error) {
        return (
            <div className={classes.errorContainer}>
                <Typography variant="h6" style={{ color: CapeeshColors.Gray1, textAlign: 'center' }}>
                    {error}
                </Typography>
            </div>
        )
    }

    if (!tokenApplied || !studentAuth.studentLoggedIn) {
        return (
            <div className={classes.loadingContainer}>
                <CircularProgress />
            </div>
        )
    }

    return (
        <div className={classes.root}>
            <MainMenu />
        </div>
    )
}

const mapStateToProps = (state) => {
    const { student, studentAuth, studentCourse } = state
    return {
        student,
        studentAuth,
        studentCourse,
    }
}

export default connect(mapStateToProps)(StudentEmbed)
